





























































import { Component, PropSync, Vue } from "vue-property-decorator";
import { dispatchSetBranch } from "@/store/gitlab/actions";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";
import {
  readEntries,
  readEntriesArray,
  readFLCID
} from "@/store/uniabc/getters";
import { dispatchLoadEntries } from "@/store/uniabc/actions";
import { api } from "@/api";
import { readGitLabInfo } from "@/store/gitlab/getters";

@Component
export default class MitigateFailedCommit extends Vue {
  dialog = false;
  isDownloaded = false;

  newBranch = "";

  @PropSync("comMsg", { type: String }) commitMessage!: string;

  get closeText() {
    return this.isDownloaded ? "Close" : "Cancel";
  }

  openMitigation() {
    this.dialog = true;
  }

  private async performMitigation() {
    try {
      const projId = readGitLabInfo(this.$store).projectId;
      const lastCommit = readFLCID(this.$store);
      const response = await api.postCreateNewBranch(
        projId,
        this.newBranch,
        lastCommit
      );
      await dispatchSetBranch(this.$store, this.newBranch);
      this.$emit("performCommit", { mitigation: true });

      this.dialog = false;
    } catch (e) {
      await dispatchRaiseErrorTimeout(
        this.$store,
        new Error(
          `Error while performing Mitigation. Please download the JSON-File and perform mitigation manually.<br> Error: ${e}`
        )
      );
    }
  }

  // https://forum.vuejs.org/t/saving-form-data/38714
  private async downloadJson() {
    try {
      const jsonData = JSON.stringify(readEntriesArray(this.$store)(), null, 4);
      const filename = "uniabc.json";

      const blob = new Blob([jsonData], { type: "text/plain;charset=utf-8;" });
      const link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      this.isDownloaded = true;
    } catch (e) {
      await dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Error while creating JSON File:<br>${e}`)
      );
    }
  }
}
